import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { DetailsTableconstant } from "./DetailsTableConstant";


const initialState = {
    DetailsTableList: [],
    DetailsTable: {

        isLoading: false,


    },
}

export const DetailsTableReducer = persistReducer(

    {
        storage,
        key: "DetailsTable",
        whitelist: [' DetailsTableList'],

    },

    (state = initialState, { type, payload }) => {
        switch (type) {
            case DetailsTableconstant.DETAILS_TABLE_REQUEST: {
          

                return {
                    ...state,
                    DetailsTableList: [],
                    DetailsTable: {

                        isLoading: true,


                    },
                };
            }

            case DetailsTableconstant.DETAILS_TABLE_RESPONSE: {

                return {
                    ...state,
                    DetailsTableList: payload,
                    DetailsTable: {

                        isLoading: false,


                    },
                };
            }

            default:
                return state;
        }
    }
);